var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.3333C6 11.3333 10.6667 12 12.6667 14H13.3333C13.7015 14 14 13.7015 14 13.3333V9.29133C14.5751 9.14333 15 8.62127 15 8C15 7.37873 14.5751 6.85667 14 6.70867V2.66667C14 2.29848 13.7015 2 13.3333 2H12.6667C10.6667 4 6 4.66667 6 4.66667H3.33333C2.59695 4.66667 2 5.26362 2 6V10C2 10.7364 2.59695 11.3333 3.33333 11.3333H4L4.66667 14.6667H6V11.3333ZM7.33333 5.77413C7.78887 5.6764 8.35167 5.54129 8.95953 5.36249C10.0783 5.03343 11.5 4.51508 12.6667 3.71639V12.2836C11.5 11.4849 10.0783 10.9666 8.95953 10.6375C8.35167 10.4587 7.78887 10.3236 7.33333 10.2259V5.77413ZM3.33333 6H6V10H3.33333V6Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorn);
export default __webpack_public_path__ + "static/media/horn.585f23fafb6cec6b1ce689e05796e347.svg";
export { ForwardRef as ReactComponent };